module.exports = __webpack_public_path__ + "img/88.b28700ff.jpg";